import React from 'react';
import Search from './Search';
import TablaCliente from './TablaCliente';

const FirstStep = props => (
  <div>
  
    {
        <Search
          searchInput={props.searchInput}
          searchOption={props.searchOption}
          onChangeValue={props.onChangeValue}
          onChangeSelect={props.onChangeSelect}
          search={props.search}
        />
    }
    {
        <TablaCliente
          clientes={props.clientes}
          paginateClient={props.paginateClient}
          showClientProform={props.showClientProform}
        />
    }
    
    <div className='modal-actions'>
      <button
        type='submit'
        className='btn btn-primary pull-right'
        onClick={props.nextStep}
        disabled={props.selectedProform.length < 1}
      >
        Siguiente
      </button>
    </div>
  </div>
);

export default FirstStep;



// WEBPACK FOOTER //
// ./src/pages/modals/CambiarCliente/FirstStep.js